import { __assign } from "tslib";
import { useEffect } from 'react';
export var GlobalErrorHandler = function (_a) {
    var onError = _a.onError;
    useEffect(function () {
        var reportError = function (error, source, additionalInfo) {
            try {
                // @TODO: sent to DD
                error.message = "[GlobalErrorHandler] ".concat(source, ": ").concat(error.message);
                console.error(error, __assign({ timestamp: new Date().toISOString(), url: window.location.href, userAgent: navigator.userAgent }, additionalInfo));
                // // Call custom error handler
                onError === null || onError === void 0 ? void 0 : onError(error, source);
            }
            catch (reportingError) {
                console.error('[GlobalErrorHandler] Error reporting failed:', reportingError);
            }
        };
        var handleError = function (event) {
            var error = event.error || new Error(event.message);
            reportError(error, 'uncaught', {
                colno: event.colno,
                filename: event.filename,
                lineno: event.lineno,
            });
        };
        var handleUnhandledRejection = function (event) {
            var error = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
            reportError(error, 'unhandled-rejection', {
                reason: event.reason,
            });
        };
        window.addEventListener('error', handleError);
        window.addEventListener('unhandledrejection', handleUnhandledRejection);
        return function () {
            window.removeEventListener('error', handleError);
            window.removeEventListener('unhandledrejection', handleUnhandledRejection);
        };
    }, [onError]);
    return null;
};
//# sourceMappingURL=GlobalErrorHandler.js.map